import LeaveLimitList from "./pages/ListPage.vue";
import LeaveLimitDetail from "./pages/FormPage.vue";
import LeaveLimitIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/leave_limit",
    component: LeaveLimitIndex,
    redirect: "/leave_limit/list",
    name: "leave_limit",
    children: [
      {
        path: "list",
        component: LeaveLimitList,
        name: "leave_limit.list",
      },
      {
        path: "create",
        component: LeaveLimitDetail,
        name: "leave_limit.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: LeaveLimitDetail,
        name: "leave_limit.edit",
        props: { create: false },
      },
    ],
  },
];
